import { useAuth } from '@clerk/clerk-react'
import { useEffect } from 'react'
import { setClerkTokenGetter } from '../api/client'

/**
 * Wires Clerk's `useAuth().getToken()` into the non-React api client.
 *
 * Mounts as a no-op child of ClerkProvider. On each render it hands the
 * current `getToken` reference to the api module; subsequent fetches
 * pick up the caller's active Clerk session token.
 *
 * We pass `skipCache: true` so the token always reflects the current
 * active org. Without it, Clerk can serve a cached token minted before
 * the user selected an org via `<OrganizationSwitcher>`, which leaves
 * the JWT missing its `org_id` claim and the backend rejects the
 * request with "No active organization". The cost is one extra
 * round-trip to Clerk per backend call — in practice ~50ms, and not
 * on the hot path (chat turns hit the student-token path, not Clerk).
 */
export default function ClerkTokenBridge() {
  const { getToken } = useAuth()
  useEffect(() => {
    setClerkTokenGetter(() => getToken({ skipCache: true }))
  }, [getToken])
  return null
}
